import { render, staticRenderFns } from "./SpareTable.vue?vue&type=template&id=1cd1c189&scoped=true&"
import script from "./SpareTable.vue?vue&type=script&lang=js&"
export * from "./SpareTable.vue?vue&type=script&lang=js&"
import style0 from "./SpareTable.vue?vue&type=style&index=0&id=1cd1c189&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd1c189",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cd1c189')) {
      api.createRecord('1cd1c189', component.options)
    } else {
      api.reload('1cd1c189', component.options)
    }
    module.hot.accept("./SpareTable.vue?vue&type=template&id=1cd1c189&scoped=true&", function () {
      api.rerender('1cd1c189', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/Vender/components/OverDeliveryPart/SpareTable.vue"
export default component.exports